import React from 'react';
import { Helmet } from 'react-helmet-async';
import NavBar from '../components/Navbar';
import Footer from '../components/Footer';
import { generateWhatsAppLink } from '../utils/whatsapp';

const Industria = () => {
  const wpp = generateWhatsAppLink('industria', 'industria-page');
  return (
    <div>
      <Helmet>
        <title>Luminárias de LED para Indústria | Sustenta LED</title>
        <meta name="description" content="Sustenta LED é distribuidora, atacadista e representante de luminárias LED industriais. Atendemos indústrias com equipe especializada e soluções completas." />
      </Helmet>
      <NavBar />
      <section className="section" style={{ paddingTop: '120px' }}>
        <div className="container">
          <div className="row align-items-center">
            <div className="col-lg-6">
              <h1 style={{fontWeight: 900}}>Luminárias de LED para Indústria</h1>
              <p>Atendemos o setor industrial com soluções de iluminação LED de alta performance, eficiência energética e segurança. Somos atacadistas, distribuidores e representantes das principais marcas, oferecendo produtos homologados e suporte técnico especializado para fábricas, galpões e linhas de produção.</p>
              <p>Nossa equipe projeta e recomenda luminárias adequadas para ambientes industriais, considerando pé-direito, níveis de iluminância, resistência e normas técnicas. Trabalhamos com high bay, UFO, refletores e soluções específicas para operações 24/7.</p>
              <p>Com estoque nacional e logística ágil, garantimos prazos assertivos e atendimento consultivo para empresas de todos os portes. Solicite sua cotação e receba condições exclusivas para o seu segmento.</p>
              <div className="d-flex flex-column align-items-start">
                <a className="btn btn-success d-inline-flex align-items-center justify-content-center gap-2" href={wpp} target="_blank" rel="noopener noreferrer">
                  <i className="bi bi-whatsapp" style={{ fontSize: '18px', lineHeight: 1 }}></i>
                  Solicite agora a sua cotação e receba em até 1h
                </a>
                <button type="button" className="btn btn-outline-secondary mt-2" onClick={() => window.history.back()}>
                  Voltar à página anterior
                </button>
              </div>
            </div>
            <div className="col-lg-6">
              <img src="/img/clientes/banner_industria.jpg" alt="Luminárias de LED para Indústria - Sustenta LED" className="img-fluid rounded" />
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default Industria;
